/*
 * Copyright OpenSearch Contributors
 * SPDX-License-Identifier: Apache-2.0
 */

export { OuiSplitButton, OuiSplitButtonProps } from './split_button';
export {
  OuiSplitButtonControl,
  OuiSplitButtonControlProps,
  OuiSplitButtonColor,
} from './split_button_control';
